import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useLocale, useTranslations } from 'next-intl';
import buttonStyles from '~/components/Button/src/Button.module.css';
import linkStyles from '~/components/Link/src/Link.module.css';
import { getDefaultBuildSearch } from '~/constants/default-origin';
import { Link } from '~/i18n/navigation';
import styles from './RewardsGetStartedBanner.module.css';
const CREATE_TRIP_PATHNAME = '/map/build';
export const RewardsGetStartedBanner = () => {
  const $ = _c(17);
  const t = useTranslations("account");
  const locale = useLocale();
  let t0;
  if ($[0] !== t) {
    t0 = t("rewards_getstarted_heading");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h2 className={styles.heading}>{t0}</h2>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== locale) {
    t2 = getDefaultBuildSearch(locale);
    $[4] = locale;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `${CREATE_TRIP_PATHNAME}${t2}`;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = clsx(linkStyles.link, buttonStyles.button, buttonStyles.secondary, buttonStyles.pill, buttonStyles.large, buttonStyles.noWrap, styles.cta);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("rewards_getstarted_cta");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <span className={linkStyles.span}>{t5}</span>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <Link href={t3} className={t4} data-test-id="RewardsGetStartedCta">{t6}</Link>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t7) {
    t8 = <section className={styles.banner} data-test-id="RewardsGetStartedBanner">{t1}{t7}</section>;
    $[14] = t1;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};